// 全局渐隐指令
const fadeInDirective = {
  inserted(el, binding) {
    const { value = {} } = binding;
    const {
      threshold = 0.05,   // 触发阈值：元素进入可视区域的百分比 (0-1)，0.05表示5%可见时触发，减少白屏时间
      rootMargin = '50px', // 根元素外边距：提前50px触发，进一步减少白屏时间
      duration = 0.3,     // 动画持续时间：秒为单位，控制渐隐动画的速度
      delay = 0,           // 动画延迟时间：秒为单位，元素进入可视区域后多久开始动画
      distance = 50        // 移动距离：像素为单位，元素从下方向上移动的距离
    } = value;

    // 设置初始状态
    el.style.opacity = '0.25';
    el.style.transform = `translateY(${distance}px)`;
    el.style.transition = `opacity ${duration}s linear, transform ${duration}s linear`;

    // 创建Intersection Observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 元素进入可视区域
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
          
          // 动画完成后停止观察
          setTimeout(() => {
            observer.unobserve(el);
          }, (duration + delay) * 1000);
        }
      });
    }, {
      threshold,
      rootMargin
    });

    // 开始观察元素
    observer.observe(el);

    // 存储observer以便后续清理
    el._fadeInObserver = observer;
  },
  unbind(el) {
    // 清理observer
    if (el._fadeInObserver) {
      el._fadeInObserver.disconnect();
      delete el._fadeInObserver;
    }
  }
};

export default fadeInDirective;
